import React, { useState } from 'react';
import Button from 'js/components/button/button';
import Label from 'js/components/label/label';
import Modal from 'js/components/modal/modal';
import TextArea from 'js/components/textarea/textarea';

const LanguageRequestModal = ({ onRequest, onCancel }) => {
    const [message, setMessage] = useState('');

    return (
        <Modal
            title="Request Language"
            actionItems={
                <Button
                    disabled={!message.trim()}
                    onClick={() => onRequest(message.trim())}
                >
                    Request Language
                </Button>
            }
            onClose={onCancel}
        >
            <Label
                label="Don’t see the one you need?"
                hint={
                    <p>
                        Request support for a new language and our client
                        services team will take care of it.
                    </p>
                }
            >
                <TextArea
                    focusOnShow
                    value={message}
                    placeholder="I need support for the Klingon language for a space campaign I’m working on. Can you help?"
                    onChange={(ev) => setMessage(ev.target.value)}
                    onClear={() => setMessage('')}
                />
            </Label>
        </Modal>
    );
};

export default LanguageRequestModal;
